export const isStaging = process.env.REACT_APP_BUILD_TYPE === "Staging";
export const isUat =
  process.env.REACT_APP_BUILD_TYPE !== "Staging" &&
  process.env.REACT_APP_BUILD_TYPE !== "Production";

let baseUrl = "https://assess-api.clevry.com";

if (isStaging) {
  baseUrl = "https://staging-assess-api.clevry.com";
} else if (isUat) {
  baseUrl = "https://clevry-clevry-assessor-v1.api.avamae.co.uk";
}

export const BASE_URL = baseUrl;

export const endpoints = {
  auth: {
    login: "/api/v1/publicrole/authmodule/login",
    refreshAccessToken: "/api/v1/publicrole/authmodule/refresh",
    requestpasswordreset:
      "/api/v1/publicrole/forgottenpasswordmodule/requestpasswordreset",
    resetpassword: "/api/v1/publicrole/forgottenpasswordmodule/resetpassword",
    initialisepassword:
      "/api/v1/publicrole/forgottenpasswordmodule/resetpassword",
  },
  adminUsers: {
    listusers: "/api/v1/adminrole/adminusersmodule/list",
    viewuser: "/api/v1/adminrole/adminusersmodule/view",
    createUser: "/api/v1/adminrole/adminusersmodule/create",
    edituser: "/api/v1/adminrole/adminusersmodule/edit",
    deleteusers: "/api/v1/adminrole/adminusersmodule/delete",
  },
  dashboard: {
    clientprojectdetails: `${BASE_URL}/api/v1/assessorrole/dashboardmodule/clientprojectsdetails`,
    reviewassessmentsdetails: `${BASE_URL}/api/v1/assessorrole/dashboardmodule/reviewassessmentsdetails`,
    contactemployer: "/api/v1/assessorrole/dashboardmodule/contactemployer",
    getcontactemployerdetails:
      "/api/v1/assessorrole/dashboardmodule/getcontactemployerdetails",
    
  },
  // FYJ endpoints
  forgottenPassword: {
    requestPasswordReset:
      "/api/v1/publicrole/forgottenpasswordmodule/requestpasswordreset",
    resetPassword: "/api/v1/publicrole/forgottenpasswordmodule/resetpassword",
  },

  staticContent: {
    list: "/api/v1/adminrole/webpagespartsmodule/list",
    create: "/api/v1/adminrole/webpagespartsmodule/create",
    edit: "/api/v1/adminrole/webpagespartsmodule/edit",
    view: "/api/v1/adminrole/webpagespartsmodule/view",
    delete: "/api/v1/adminrole/webpagespartsmodule/delete",
  },
  recordedInterview: {
    candidateToAssess: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/candidatetoassess`,
    assessInterviewDetails: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/assessinterviewdetails`,
    saveCapabilityAnswers: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/savecapabilityanswers`,
    candidateFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/candidatefeedbackdetails`,
    saveCandidateFeedback: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/savecandidatefeedback`,
    assessorFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/assessorfeedbackdetails`,
    saveAssessorFeedback: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/saveassessorfeedback`,
    submitAssessorsReview: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/submitassessorsreview`,
    saveSkipTotalScore: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/submitmanualtotalscore`,
    saveNote: `${BASE_URL}/api/v1/assessorrole/recordedinterviewmodule/savenote`,
  },
  presentationActivity: {
    candidateToAssess: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/candidatetoassess`,
    assessInterviewDetails: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/assessinterviewdetails`,
    saveCapabilityAnswers: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/savecapabilityanswers`,
    candidateFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/candidatefeedbackdetails`,
    saveCandidateFeedback: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/savecandidatefeedback`,
    assessorFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/assessorfeedbackdetails`,
    saveAssessorFeedback: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/saveassessorfeedback`,
    submitAssessorsReview: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/submitassessorsreview`,
    saveSkipTotalScore: '',
    saveNote: `${BASE_URL}/api/v1/assessorrole/PresentationActivitymodule/savenote`,
  },
  businessCaseActivity: {
    candidateToAssess: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/candidatetoassess`,
    assessBusinessCaseDetails: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/assessbusinesscasedetails`,
    saveCapabilityAnswers: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/savecapabilityanswers`,
    candidateFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/candidatefeedbackdetails`,
    saveCandidateFeedback: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/savecandidatefeedback`,
    assessorFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/assessorfeedbackdetails`,
    saveAssessorFeedback: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/saveassessorfeedback`,
    submitAssessorsReview: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/submitassessorsreview`,
    saveSkipTotalScore: '',
    saveNote: `${BASE_URL}/api/v1/assessorrole/BusinessCasemodule/savenote`,
  },
  bookingModule: {
    searchContactsUrl: `${BASE_URL}/api/calendarmodule/events/usercontacts`,
    createUrl: `${BASE_URL}/api/calendarmodule/events/create`,
    editUrl: `${BASE_URL}/api/calendarmodule/events/edit`,
    eventsSummaryUrl: `${BASE_URL}/api/calendarmodule/events/summaries`,
    cancelMeetingUrl: `${BASE_URL}/api/v1/assessorrole/bookingmodule/requestcancel`,
    declineMeetingUrl: `${BASE_URL}/api/calendarmodule/events/decline`,
    acceptMeetingUrl: `${BASE_URL}/api/calendarmodule/events/accept`,
    createAvailability: `${BASE_URL}/api/calendarmodule/availabilities/create-availabilities`,
    editAvailability: `${BASE_URL}/api/calendarmodule/availabilities/edit`,
    getAvailability: `${BASE_URL}/api/calendarmodule/availabilities/summaries`,
  },
  messages: {
    accept: "/api/communicationsmodule/chats/accept",
    decline: "/api/communicationsmodule/chats/decline",
    details: "/api/communicationsmodule/chats/details",
    getMessageAttachment:
      "/api/communicationsmodule/chats/getmessageattachment",
    recentChats: "/api/communicationsmodule/chats/recent",
    sendChatMessage: "/api/communicationsmodule/chats/sendmessage",
    createForContact: "/api/communicationsmodule/chats/createforcontact",
    getUnreadMessageCount: "/api/communicationsmodule/chats/unreadmessagecount",
    getUnreadMessageDetails:
      "/api/communicationsmodule/chats/unreadmessagedetails",
    contactEmployer: `/api/v1/candidaterole/jobapplicationmodule/contactemployer`,
    getContactEmployerDetails: `/api/v1/candidaterole/jobapplicationmodule/getcontactemployerdetails`,
  },
  virtualTeamDiscussion: {
    createAndJoinRoom: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/createandjoinroom`,
    candidateToAssess: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/candidatetoassess`,
    assessInterviewDetails: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/assessinterviewdetails`,
    saveCapabilityAnswers: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/savecapabilityanswers`,
    candidateFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/candidatefeedbackdetails`,
    saveCandidateFeedback: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/savecandidatefeedback`,
    assessorFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/assessorfeedbackdetails`,
    saveAssessorFeedback: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/saveassessorfeedback`,
    submitAssessorsReview: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/submitassessorsreview`,
    saveSkipTotalScore: '',
    saveNote: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/savenote`,
    saveLiveNote: `${BASE_URL}/api/v1/assessorrole/virtualteamdiscussionmodule/savelivenote`,
  },
  virtualMeeting: {
    createAndJoinRoom: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/createandjoinroom`,
    candidateToAssess: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/candidatetoassess`,
    assessInterviewDetails: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/assessinterviewdetails`,
    saveCapabilityAnswers: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/savecapabilityanswers`,
    candidateFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/candidatefeedbackdetails`,
    saveCandidateFeedback: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/savecandidatefeedback`,
    assessorFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/assessorfeedbackdetails`,
    saveAssessorFeedback: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/saveassessorfeedback`,
    submitAssessorsReview: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/submitassessorsreview`,
    saveSkipTotalScore: '',
    saveNote: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/savenote`,
    saveLiveNote: `${BASE_URL}/api/v1/assessorrole/virtualmeetingmodule/savelivenote`,
  },
  liveInterview: {
    createAndJoinRoom: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/createandjoinroom`,
    candidateToAssess: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/candidatetoassess`,
    assessInterviewDetails: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/assessinterviewdetails`,
    saveCapabilityAnswers: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/savecapabilityanswers`,
    candidateFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/candidatefeedbackdetails`,
    saveCandidateFeedback: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/savecandidatefeedback`,
    assessorFeedbackDetails: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/assessorfeedbackdetails`,
    saveAssessorFeedback: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/saveassessorfeedback`,
    submitAssessorsReview: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/submitassessorsreview`,
    saveSkipTotalScore: '',
    saveNote: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/savenote`,
    saveLiveNote: `${BASE_URL}/api/v1/assessorrole/liveinterviewmodule/savelivenote`,
  },
};
